<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="LegalTerms" v-html="displayHTM" />
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LegalTerms",
  props: {
    term: { type: String, required: true },
  },
  data() {
    return {
      displayHTM: `<div class="v-div headline mt-3">Loading ${this.term} Terms</div>`,
    };
  },
  computed: {
    ...mapState({
      terms: (state) => state.theme.terms,
    }),
  },
  mounted() {
    const source = this.terms[this.term];

    this.$axios
      .$get(source, {
        baseURL: "",
        headers: {
          Accept: "text/html",
        },
      })
      .then((data) => {
        this.displayHTM = this.$sanitize(data, {
          allowedTags: [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "div",
            "a",
            "img",
            "ul",
            "ol",
            "li",
            "p",
            "i",
            "strong",
            "span",
            "hr",
            "style",
            "table",
            "thead",
            "tbody",
            "th",
            "tr",
            "td",
            "br",
            "em",
            "noscript",
            "iframe",
          ],
          allowedAttributes: {
            h1: ["class"],
            h2: ["class"],
            h3: ["class"],
            h4: ["class"],
            div: ["class", "style", "aria-label"],
            p: ["class"],
            i: ["class", "style", "aria-label", "aria-hidden"],
            a: ["href", "target", "aria-label", "role"],
            img: ["src", "alt", "style"],
            ul: ["class"],
            ol: ["class", "type"],
            span: ["class", "style", "aria-label"],
            table: ["class"],
            iframe: ["src", "allow", "style", "title"],
          },
          selfClosing: ["br"],
        });
      });
  },
};
</script>
